module.exports = __webpack_public_path__ + "static/media/Other_Literary_Societies.b8e1c548.md";